import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import React, { Fragment } from 'react'
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import estilos from '../Tabs/TabsInspeccionarComponent.module.css'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { useContext } from 'react';
import InspectorEnCampoContext from '../../Context/InspectorEnCampoContext';
import { getTipoEquipoByIdArea } from '../../../../redux/DucksUnidadInspeccion/TipoEquipoDuck';
import { getElementoSeccionByIdArea } from '../../../../redux/DucksUnidadInspeccion/ElementoSeccionDuck';
import { getProcesoByIdArea } from '../../../../redux/DucksUnidadInspeccion/ProcesosDuck';
import { insertFi25Procesos } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoProcesosDuck';
import { insertEquipoHistorial } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoEquipoHistorial';
import { insertDataElementoClienteHistorial } from '../../../../redux/DucksUnidadInspeccion/DataElementoClienteHistorialDuck';
import { getanexoByIdInforme } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { insertSuperficie } from '../../../../redux/DucksUnidadInspeccion/SuperficieDuck';

import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'
import { gridColumnVisibilityModelSelector } from '@mui/x-data-grid';

//import { obtenerCategoria, totalCategoria, setTotalCategoria } from '../../InspectorUtils/CategoriaMezcal'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1300,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function DestilacionFormComponent(props) {

    const dispatch = useDispatch();

    const { coccionContext, destilacionContext, fermentacionContext, moliendaContext, pesadoContext, setContextDestilacion } = useContext(InspectorEnCampoContext);
    const [totalCategoria, setTotalCategoria] = React.useState("");
    const [isContext, setIsContext] = React.useState(false);

    const tipoequipo = useSelector(store => store.ElementoSeccion.ElementoSeccion);
    const procesos = useSelector(store => store.Procesos.Proceso);

    const todo = props.detalles;
    const idinforme = props.idinforme;
    const idanexo = useSelector(store => store.anexo.anexo);
    const instalacion = props.instalacion - 1;
    //const [totalCategoria, setTotalCategoria] = React.useState("");
    const [informacionFormik, setInformacionFormik] = React.useState(
        {
            cantidad: '',
            capacidad: '',
            descripcion: '',
            condicion: '',
            largo: '',
            ancho: '',
            area: ''
        }
    );

    const [equipoDestilacion, setequipoDestilacion] = React.useState([]);
    const [procesosDestilacion, setProcesosDestilacion] = React.useState([]);

    //const initialValues = {
    //    equipoDestilacion
    //};

    const [initialValues, setInitialValues] = React.useState({
        directo: '',
        indirecto: '',
        equipoDestilacion: equipoDestilacion,
        procesosDestilacion: procesosDestilacion,
        largo: 0,
        ancho: 0,
        area: 0
    })



    const [informacionFormikModal, setInformacionFormikModal] = React.useState(
        {
            tipo: '',
            cantidad: '',
            capacidad: '',
            descripcion: '',
            condicion: '',
            largo: '',
            ancho: '',
            area: ''
        }
    );



    const [openModalNuevoEquipo, setOpenModalNuevoEquipo] = React.useState(false);

    const [editarEquipo, setEditarEquipo] = React.useState(true);

    useEffect(() => {
        obtenerCategoria()
    }, [])

    useEffect(() => {

        //dispatch(getTipoEquipoByIdArea(4))
        dispatch(getElementoSeccionByIdArea(4))
        dispatch(getProcesoByIdArea(4))
        // if (idinforme?.idfi_25_informecumplimientonom) {
        //     dispatch(getanexoByIdInforme(idinforme.idfi_25_informecumplimientonom)) //informe
        // }


        if (destilacionContext != null) {
            setequipoDestilacion(destilacionContext.equipoDestilacion)
            setIsContext(true)
            setInitialValues({
                directo: destilacionContext.directo,
                indirecto: destilacionContext.indirecto,
                equipoDestilacion: equipoDestilacion,
                procesosDestilacion: procesosDestilacion,
                largo: destilacionContext.superficie?.data?.largo,
                ancho: destilacionContext.superficie?.data?.ancho,
                area: destilacionContext.superficie?.data?.area
            })
        } else {
            if (isContext === false) {
                todo.anexocliente[instalacion].dataelementocliente.map((equipo, index) => {
                    if (equipo.idseccion === 4) {

                        let capacidad = parseInt(equipo.descripcion)

                        if (isNaN(capacidad)) {
                            setequipoDestilacion([...equipoDestilacion, {
                                cantidad: equipo.cantidad,
                                descripcion: equipo.descripcion,
                                elemento: {
                                    idelemento: equipo.elemento.idelemento,
                                    nombreelemento: equipo.elemento.nombreelemento
                                },
                                idanexocliente: equipo.idanexocliente,
                                iddataelementocliente: equipo.iddataelementocliente,
                                idelemento: equipo.idelemento,
                                idseccion: equipo.idseccion,
                                otro: equipo.otro
                            }])
                        } else {
                            setequipoDestilacion([...equipoDestilacion, {
                                cantidad: equipo.cantidad,
                                descripcion: "",
                                capacidad: equipo.descripcion,
                                elemento: {
                                    idelemento: equipo.elemento.idelemento,
                                    nombreelemento: equipo.elemento.nombreelemento
                                },
                                idanexocliente: equipo.idanexocliente,
                                iddataelementocliente: equipo.iddataelementocliente,
                                idelemento: equipo.idelemento,
                                idseccion: equipo.idseccion,
                                otro: equipo.otro
                            }])
                        }
                    }
                })
            }
        }

    }, [todo])

    const handleModificar = () => {
        setEditarEquipo(!editarEquipo);
    }

    const handleOpenModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(true);
    }
    const handleCloseModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(false);
    }

    useEffect(() => {
        initialValues
    }, [initialValues])

    const handleNuevoEquipo = (valores) => {

        let equipoSeleccionado = tipoequipo.filter((t) => valores.tipo == t.idelemento)

        setequipoDestilacion([...equipoDestilacion, {
            cantidad: valores.cantidad,
            capacidad: valores.capacidad,
            condicion: valores.condicion,
            descripcion: valores.descripcion,
            elemento: {
                idelemento: valores.tipo,
                tipoOtros: valores.tipoOtros,
                nombreelemento: equipoSeleccionado[0].elemento.nombreelemento
            },
            //idanexocliente: 1,
            //iddataelemntocliente: 1,
            //idseccion: 1,
            otro: null
        }])

        handleCloseModalNuevoEquipo();
    }

    const handleEliminarEquipo = (elemento) => {
        let nuevoEquipo = equipoDestilacion.filter((equipo) => equipo !== elemento);
        setequipoDestilacion(nuevoEquipo);
    }

    useEffect(() => {

        if (destilacionContext != null) {
            setInitialValues({
                ...initialValues,
                directo: destilacionContext.directo,
                indirecto: destilacionContext.indirecto,
                equipoDestilacion: equipoDestilacion,
                procesos: destilacionContext.procesos,
                largo: destilacionContext.superficie?.data?.largo,
                ancho: destilacionContext.superficie?.data?.ancho,
                area: destilacionContext.superficie?.data?.area
            })
        } else {
            setInitialValues({
                ...initialValues,
                equipoDestilacion: equipoDestilacion,
            })
        }
        obtenerCategoria()
    }, [equipoDestilacion, destilacionContext?.equipoDestilacion])

    useEffect(() => {
        totalCategoria
    }, [totalCategoria])

    useEffect(() => {
        procesos.forEach(element => {
            if (element.idseccion == 4) {
                procesosDestilacion.push(element)
            }
        })
    }, [procesos])

    useEffect(() => {
        procesosDestilacion
    }, [procesosDestilacion])

    const obtenerCategoria = () => {
        let coccion = []
        let molienda = []
        let fermentacion = []
        let destilacion = []
        let haymayor = false;

        //1
        let mezcal = 0;
        //2
        let mezcalartesanal = 0;
        //3
        let mezcalancestral = 0;

        if (coccionContext != null) {
            coccionContext.equipoCoccion.map((e) => {
                coccion.push(e.elemento.nombreelemento)
            })
        }

        coccion = coccion.filter((e, index) => {
            return coccion.indexOf(e) === index;
        })

        if (moliendaContext != null) {
            moliendaContext.equipoMolienda.map((e) => {
                molienda.push(e.elemento.nombreelemento)
            })
        }

        molienda = molienda.filter((e, index) => {
            return molienda.indexOf(e) === index;
        })

        if (fermentacionContext != null) {
            fermentacionContext.equipoFermentacion.map((e) => {
                fermentacion.push(e.elemento.nombreelemento)
            })
        }

        fermentacion = fermentacion.filter((e, index) => {
            return fermentacion.indexOf(e) === index;
        })

        if (destilacionContext != null) {
            destilacionContext.equipoDestilacion.map((e) => {
                destilacion.push(e.elemento.nombreelemento)
            })
        }

        destilacion = destilacion.filter((e, index) => {
            return destilacion.indexOf(e) === index;
        })

        /////////////PRIMERA CONDICION
        if (coccion.includes("Horno de pozo")) {
            mezcal += 1;
            mezcalartesanal += 1;
            mezcalancestral += 1;

            //MOLIENDA

            if (molienda.includes("Mazo de madera")) {
                if (fermentacion.includes("Tanques de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Destiladores continuos")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Columna de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Columna de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                mezcalartesanal += 1;
                mezcalancestral += 1;
            }
            if (molienda.includes("Tahona, molino chileno o egipcio")) {
                mezcal += 1;
                mezcalartesanal += 1;
                mezcalancestral += 1;
            }
            if (molienda.includes("Trapiche")) {
                if (destilacion.includes("Olla de barro-Montera de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                mezcal += 1;
                mezcalartesanal += 1;
            }
            if (molienda.includes("Desgarradora")) {
                if (destilacion.includes("Olla de barro-Montera de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                mezcal += 1;
                mezcalartesanal += 1;
            }
            if (molienda.includes("Tren de molinos")) {
                mezcal += 1;
                if (fermentacion.includes("Oquedades en piedra")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Oquedades en suelo")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Oquedades en tronco")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Pieles de animal")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Recipientes de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de barro")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                setTotalCategoria("mezcal")
                return "mezcal"

            }
            if (molienda.includes("Difusor")) {
                mezcal += 1;
                if (fermentacion.includes("Oquedades en piedra")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Oquedades en suelo")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Oquedades en tronco")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Pieles de animal")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Recipientes de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de barro")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                setTotalCategoria("mezcal")
                return "mezcal"

            }

            //FERMENTACION
            if (fermentacion.includes("Oquedades en piedra")) {
                if (destilacion.includes("Alambique de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Destiladores continuos")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Columna de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Columna de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                mezcalartesanal += 1;
                mezcalancestral += 1;
            }
            if (fermentacion.includes("Oquedades en suelo")) {
                mezcalartesanal += 1;
                mezcalancestral += 1;
            }
            if (fermentacion.includes("Oquedades en tronco")) {
                mezcalartesanal += 1;
                mezcalancestral += 1;
            }
            if (fermentacion.includes("Pieles de animal")) {
                mezcalartesanal += 1;
                mezcalancestral += 1;
            }
            if (fermentacion.includes("Recipientes de barro")) {
                mezcalartesanal += 1;
                mezcalancestral += 1;
            }
            if (fermentacion.includes("Recipientes de madera")) {
                mezcal += 1;
                mezcalartesanal += 1;
                mezcalancestral += 1;
            }
            if (fermentacion.includes("Piletas de mampostería")) {
                mezcal += 1;
                mezcalartesanal += 1;
                mezcalancestral += 1;
            }
            if (fermentacion.includes("Tanques de acero inoxidable")) {
                mezcal += 1;
                if (destilacion.includes("Olla de barro-Montera de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de barro")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de madera")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""

                }
                setTotalCategoria("mezcal")
                return "mezcal"

            }

            //DESTILACION
            if (destilacion.includes("Olla de barro-Montera de barro")) {
                mezcalancestral += 1;
                //setTotalCategoria("mezcalancestral")
                //return "mezcalancestral"
            }
            if (destilacion.includes("Olla de barro-Montera de madera")) {
                mezcalancestral += 1;
                //setTotalCategoria("mezcalancestral")
                //return "mezcalancestral"
            }
            if (destilacion.includes("Olla de barro-Montera de cobre")) {
                mezcalancestral += 1;
                //setTotalCategoria("mezcalancestral")
                //return "mezcalancestral"
            }
            if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                mezcalancestral += 1;
                //setTotalCategoria("mezcalancestral")
                //return "mezcalancestral"
            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de barro")) {
                mezcalartesanal += 1;
                //setTotalCategoria("mezcalartesanal")
                //return "mezcalartesanal"

            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de madera")) {
                mezcalartesanal += 1;
                //setTotalCategoria("mezcalartesanal")
                //return "mezcalartesanal"

            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de cobre")) {
                mezcalartesanal += 1;
                //setTotalCategoria("mezcalartesanal")
                //return "mezcalartesanal"

            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de acero inoxidable")) {
                mezcalartesanal += 1;
                //setTotalCategoria("mezcalartesanal")
                //return "mezcalartesanal"

            }//
            if (destilacion.includes("Alambique de acero inoxidable")) {
                mezcal += 1;
                //setTotalCategoria("mezcal")
                //return "mezcalartesanal"

            }
            if (destilacion.includes("Destiladores continuos")) {
                mezcal += 1;
                //setTotalCategoria("mezcal")
                //return "mezcalartesanal"
            }
            if (destilacion.includes("Columna de cobre")) {
                mezcal += 1;
                //setTotalCategoria("mezcal")
                //return "mezcalartesanal"
            }
            if (destilacion.includes("Columna de acero inoxidable")) {
                mezcal += 1;
                //setTotalCategoria("mezcal")
                //return "mezcalartesanal"
                //mezcalartesanal = 0;
                //mezcalancestral = 0;
            }

            if (mezcal > mezcalartesanal && mezcal > mezcalancestral) {
                //console.log("mezcal")
                setTotalCategoria("mezcal")
                haymayor = true;
            }

            if (mezcalartesanal > mezcal && mezcalartesanal > mezcalancestral) {
                //console.log("mezcalartesanal")
                setTotalCategoria("mezcalartesanal")
                haymayor = true;
            }

            if (mezcalancestral > mezcalartesanal && mezcalancestral > mezcal) {
                //console.log("mezcalancestral")
                setTotalCategoria("mezcalancestral")
                haymayor = true;
            }

            if (haymayor === false) {
                //1
                if (mezcal === mezcalartesanal) {
                    //console.log("mezcal y mezcalartesanal")
                    setTotalCategoria("mezcal y mezcalartesanal")
                }

                if (mezcal === mezcalancestral) {
                    //console.log("mezcal y mezcalancestral")
                    setTotalCategoria("mezcal y mezcalancestral")
                }

                //2
                if (mezcalartesanal === mezcal) {
                    //console.log("mezcalartesanal y mezcal")
                    setTotalCategoria("mezcalartesanal y mezcal")
                }

                if (mezcalartesanal === mezcalancestral) {
                    //console.log("mezcalartesanal y mezcalancestral")
                    setTotalCategoria("mezcalartesanal y mezcalancestral")
                }

                //3
                if (mezcalancestral === mezcal) {
                    //console.log("mezcalancestral y mezcal")
                    setTotalCategoria("mezcalancestral y mezcal")
                }

                if (mezcalancestral === mezcalartesanal) {
                    //console.log("mezcalancestral y mezcalartesanal")
                    setTotalCategoria("mezcalancestral y mezcalartesanal")
                }

                if (mezcalancestral === mezcalartesanal) {
                    //console.log("mezcalancestral y mezcalartesanal")
                    setTotalCategoria("mezcalancestral y mezcalartesanal")
                }

                if (mezcal === mezcalancestral && mezcal === mezcalartesanal) {
                    //console.log("mezcalancestral y mezcalartesanal")
                    setTotalCategoria("mezcal, mezcalancestral y mezcalartesanal")
                }
            }

            if (mezcal === 0 && mezcalancestral === 0 && mezcalartesanal === 0) {
                setTotalCategoria("")
            }
        }

        ////////////SEGUNDA CONDICION
        if (coccion.includes("Horno de mampostería")) {
            mezcal += 1;
            mezcalartesanal += 1;

            // INDETERMINADAS
            if (destilacion.includes("Olla de barro-Montera de barro")) {
                setTotalCategoria("")
                return ""
            }
            if (destilacion.includes("Olla de barro-Montera de madera")) {
                setTotalCategoria("")
                return ""
            }
            if (destilacion.includes("Olla de barro-Montera de cobre")) {
                setTotalCategoria("")
                return ""
            }
            if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                setTotalCategoria("")
                return ""
            }

            //MOLIENDA
            if (molienda.includes("Mazo de madera")) {
                mezcalartesanal += 1;
                if (fermentacion.includes("Tanques de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Destiladores continuos")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Columna de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Columna de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                //mezcalancestral += 1;
            }
            if (molienda.includes("Tahona, molino chileno o egipcio")) {
                mezcal += 1;
                mezcalartesanal += 1;
                //mezcalancestral += 1;
            }
            if (molienda.includes("Trapiche")) {
                if (destilacion.includes("Olla de barro-Montera de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                mezcal += 1;
                mezcalartesanal += 1;
            }
            if (molienda.includes("Desgarradora")) {
                if (destilacion.includes("Olla de barro-Montera de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                mezcal += 1;
                mezcalartesanal += 1;
            }
            if (molienda.includes("Tren de molinos")) {
                mezcal += 1;
                if (fermentacion.includes("Oquedades en piedra")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Oquedades en suelo")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Oquedades en tronco")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Pieles de animal")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Recipientes de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de barro")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                setTotalCategoria("mezcal")
                return "mezcal"

            }
            if (molienda.includes("Difusor")) {
                mezcal += 1;
                if (fermentacion.includes("Oquedades en piedra")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Oquedades en suelo")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Oquedades en tronco")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Pieles de animal")) {
                    setTotalCategoria("")
                    return ""
                }
                if (fermentacion.includes("Recipientes de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de barro")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de madera")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""

                }
                setTotalCategoria("mezcal")
                return "mezcal"

            }

            //FERMENTACION
            if (fermentacion.includes("Oquedades en piedra")) {
                if (destilacion.includes("Alambique de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Destiladores continuos")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Columna de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Columna de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                mezcalartesanal += 1;
                //mezcalancestral += 1;
            }
            if (fermentacion.includes("Oquedades en suelo")) {
                mezcalartesanal += 1;
                //mezcalancestral += 1;
            }
            if (fermentacion.includes("Oquedades en tronco")) {
                mezcalartesanal += 1;
                //mezcalancestral += 1;
            }
            if (fermentacion.includes("Pieles de animal")) {
                mezcalartesanal += 1;
                //mezcalancestral += 1;
            }
            if (fermentacion.includes("Recipientes de barro")) {
                mezcalartesanal += 1;
                //mezcalancestral += 1;
            }
            if (fermentacion.includes("Recipientes de madera")) {
                mezcal += 1;
                mezcalartesanal += 1;
                //mezcalancestral += 1;
            }
            if (fermentacion.includes("Piletas de mampostería")) {
                mezcal += 1;
                mezcalartesanal += 1;
                //mezcalancestral += 1;
            }
            if (fermentacion.includes("Tanques de acero inoxidable")) {
                mezcal += 1;
                if (destilacion.includes("Olla de barro-Montera de barro")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de madera")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""
                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de barro")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de madera")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de cobre")) {
                    setTotalCategoria("")
                    return ""

                }
                if (destilacion.includes("Alambique con caldera de cobre-Montera de acero inoxidable")) {
                    setTotalCategoria("")
                    return ""

                }
                setTotalCategoria("mezcal")
                return "mezcal"

            }

            //DESTILACION
            if (destilacion.includes("Olla de barro-Montera de barro")) {
                //mezcalancestral += 1;
                //setTotalCategoria("mezcalancestral")
                //return "mezcalancestral"
            }
            if (destilacion.includes("Olla de barro-Montera de madera")) {
                //mezcalancestral += 1;
                //setTotalCategoria("mezcalancestral")
                //return "mezcalancestral"
            }
            if (destilacion.includes("Olla de barro-Montera de cobre")) {
                //mezcalancestral += 1;
                //setTotalCategoria("mezcalancestral")
                //return "mezcalancestral"
            }
            if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                //mezcalancestral += 1;
                //setTotalCategoria("mezcalancestral")
                //return "mezcalancestral"
            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de barro")) {
                mezcalartesanal += 1;
                //setTotalCategoria("mezcalartesanal")
                //return "mezcalartesanal"

            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de madera")) {
                mezcalartesanal += 1;
                //setTotalCategoria("mezcalartesanal")
                //return "mezcalartesanal"

            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de cobre")) {
                mezcalartesanal += 1;
                //setTotalCategoria("mezcalartesanal")
                //return "mezcalartesanal"

            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de acero inoxidable")) {
                mezcalartesanal += 1;
                //setTotalCategoria("mezcalartesanal")
                //return "mezcalartesanal"

            }
            if (destilacion.includes("Alambique de acero inoxidable")) {
                mezcal += 1;
                //setTotalCategoria("mezcal")
                //return "mezcalartesanal"

            }
            if (destilacion.includes("Destiladores continuos")) {
                mezcal += 1;
                //setTotalCategoria("mezcal")
                //return "mezcalartesanal"
            }
            if (destilacion.includes("Columna de cobre")) {
                mezcal += 1;
                //setTotalCategoria("mezcal")
                //return "mezcalartesanal"
            }
            if (destilacion.includes("Columna de acero inoxidable")) {
                mezcal += 1;
                //setTotalCategoria("mezcal")
                //return "mezcalartesanal"
                //mezcalartesanal = 0;
                //mezcalancestral = 0;
            }

            if (mezcal > mezcalartesanal && mezcal > mezcalancestral) {
                //console.log("mezcal")
                setTotalCategoria("mezcal")
                haymayor = true;
            }

            if (mezcalartesanal > mezcal && mezcalartesanal > mezcalancestral) {
                //console.log("mezcalartesanal")
                setTotalCategoria("mezcalartesanal")
                haymayor = true;
            }

            if (mezcalancestral > mezcalartesanal && mezcalancestral > mezcal) {
                //console.log("mezcalancestral")
                setTotalCategoria("mezcalancestral")
                haymayor = true;
            }

            if (haymayor === false) {
                //1
                if (mezcal === mezcalartesanal) {
                    //console.log("mezcal y mezcalartesanal")
                    setTotalCategoria("mezcal y mezcalartesanal")
                }

                if (mezcal === mezcalancestral) {
                    //console.log("mezcal y mezcalancestral")
                    setTotalCategoria("mezcal y mezcalancestral")
                }

                //2
                if (mezcalartesanal === mezcal) {
                    //console.log("mezcalartesanal y mezcal")
                    setTotalCategoria("mezcalartesanal y mezcal")
                }

                if (mezcalartesanal === mezcalancestral) {
                    //console.log("mezcalartesanal y mezcalancestral")
                    setTotalCategoria("mezcalartesanal y mezcalancestral")
                }

                //3
                if (mezcalancestral === mezcal) {
                    //console.log("mezcalancestral y mezcal")
                    setTotalCategoria("mezcalancestral y mezcal")
                }

                if (mezcalancestral === mezcalartesanal) {
                    //console.log("mezcalancestral y mezcalartesanal")
                    setTotalCategoria("mezcalancestral y mezcalartesanal")
                }

                if (mezcalancestral === mezcalartesanal) {
                    //console.log("mezcalancestral y mezcalartesanal")
                    setTotalCategoria("mezcalancestral y mezcalartesanal")
                }

                if (mezcal === mezcalancestral && mezcal === mezcalartesanal) {
                    //console.log("mezcalancestral y mezcalartesanal")
                    setTotalCategoria("mezcal, mezcalancestral y mezcalartesanal")
                }
            }
        }

        ////////////////////TERCERA CONDICION
        if (coccion.includes("Autoclave")) {
            let mezcal = 1;

            // INDETERMINADAS

            if (molienda.includes("Mazo de madera")) {
                setTotalCategoria("")
                return ""
            }
            if (fermentacion.includes("Oquedades en piedra")) {
                setTotalCategoria("")
                return ""
            }
            if (fermentacion.includes("Oquedades en suelo")) {
                setTotalCategoria("")
                return ""
            }
            if (fermentacion.includes("Oquedades en tronco")) {
                setTotalCategoria("")
                return ""
            }
            if (fermentacion.includes("Pieles de animal")) {
                setTotalCategoria("")
                return ""
            }
            if (fermentacion.includes("Recipientes de barro")) {
                setTotalCategoria("")
                return ""
            }
            if (destilacion.includes("Olla de barro-Montera de barro")) {
                setTotalCategoria("")
                return ""
            }
            if (destilacion.includes("Olla de barro-Montera de madera")) {
                setTotalCategoria("")
                return ""
            }
            if (destilacion.includes("Olla de barro-Montera de cobre")) {
                setTotalCategoria("")
                return ""
            }
            if (destilacion.includes("Olla de barro-Montera de acero inoxidable")) {
                setTotalCategoria("")
                return ""
            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de barro")) {
                setTotalCategoria("")
                return ""

            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de madera")) {
                setTotalCategoria("")
                return ""

            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de cobre")) {
                setTotalCategoria("")
                return ""

            }
            if (destilacion.includes("Alambique con caldera de cobre-Montera de acero inoxidable")) {
                setTotalCategoria("")
                return ""

            }

            setTotalCategoria("mezcal")
            return "mezcal"
            //mezcalartesanal = 0;
            //mezcalancestral = 0;
        }

    }

    const modalNuevoEquipo = () => {
        return (
            <div>
                <Modal
                    open={openModalNuevoEquipo}
                    onClose={handleCloseModalNuevoEquipo}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                Nuevo Equipo
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <Formik
                                initialValues={informacionFormikModal}
                                onSubmit={(valores) => {
                                    handleNuevoEquipo(valores)
                                }}
                            >
                                {(props) => (
                                    <Form>
                                        <div className='table-responsive'>
                                            <table className='table table-striped table-hover'>
                                                <thead>
                                                    <tr>
                                                        <th>Tipo</th>
                                                        <th>Cantidad</th>
                                                        <th>Capacidad (L)</th>
                                                        <th>Descripción y/o características</th>
                                                        <th width="120">Condición</th>
                                                        {//<th>Largo (m)</th>
                                                            //<th>Ancho (m)</th>
                                                            //<th>Área (m²)</th>
                                                        }
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="tipo"
                                                                name="tipo"
                                                                className="form-select"
                                                                multiple={false}
                                                                required
                                                            >
                                                                <option defaultValue>Seleccione Tipo de Equipo</option>
                                                                {tipoequipo.map((t, index) => (
                                                                    <option key={index} value={t.idelemento}>{t.elemento.nombreelemento}</option>
                                                                ))}
                                                            </Field>
                                                            {
                                                                props.values.tipo === "4" ?
                                                                    <div>
                                                                        <br />
                                                                        <label htmlFor='tipoOtros'>Tipo de equipo:</label>
                                                                        <Field
                                                                            type="text"
                                                                            id="tipoOtros"
                                                                            name="tipoOtros"
                                                                            className="form-control form-control-sm"
                                                                        />
                                                                    </div>
                                                                    : <div></div>
                                                            }
                                                        </td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="cantidad" name="cantidad" placeholder="Cantidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="capacidad" name="capacidad" placeholder="Capacidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="descripcion" name="descripcion" placeholder="Descripción" required /></td>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="condicion"
                                                                name="condicion"
                                                                className="form-select"
                                                                multiple={false}
                                                                required

                                                            >
                                                                <option defaultValue>Seleccione Condicion</option>
                                                                <option value={"Buena"}>Buena</option>
                                                                <option value={"Regular"}>Regular</option>
                                                                <option value={"Mala"}>Mala</option>
                                                            </Field>
                                                        </td>
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="largo" name="largo" placeholder="Largo" onChange={handleObtenerLargo} value={superficie.largo} required /></td>
                                                        }
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="ancho" name="ancho" placeholder="Ancho" onChange={handleObtenerAncho} value={superficie.ancho} required /></td>
                                                        }
                                                        {//<td><Field type="text" className="form-control form-control-sm" id="area" name="area" placeholder="Área" value={superficie.area} required /></td>
                                                        }
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <button type='submit' className="btn btn-success">GUARDAR</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validate={(valores) => {

                    const sup = {
                        data: {
                            largo: parseFloat(valores.largo),
                            ancho: parseFloat(valores.ancho),
                            area: parseFloat(valores.largo * valores.ancho),
                            //idfi_25anexo: idanexo.idfi_25anexo,
                            idseccion: 4,
                        }
                    }

                    const destilacionContext = {
                        superficie: sup,
                        directo: valores.directo,
                        indirecto: valores.indirecto,
                        equipoDestilacion: valores.equipoDestilacion,
                        procesos: valores.procesos,
                        procesosPreguntas: procesosDestilacion,
                        categoria: totalCategoria,
                        submit: false
                    }

                    setContextDestilacion(destilacionContext)

                }}
                onSubmit={(valores) => {

                    try {
                        const sup = {
                            data: {
                                largo: parseFloat(valores.largo),
                                ancho: parseFloat(valores.ancho),
                                area: parseFloat(valores.largo * valores.ancho),
                                //idfi_25anexo: idanexo.idfi_25anexo,
                                idseccion: 4,
                            }
                        }

                        dispatch(insertSuperficie(sup))

                        if (valores.procesos.length > 0) {
                            procesos.map((p, index) => {

                                const data = {
                                    data: {
                                        //idfi_25anexo: idanexo.idfi_25anexo,
                                        comentarios: valores.procesos[index],
                                        idproceso: p.idproceso,
                                    }
                                }

                                dispatch(insertFi25Procesos(data))   //Anexo Up procesos

                            })
                        } else {
                            console.log("procesos vacio")
                        }

                        if (valores.equipoDestilacion.length > 0) {
                            valores.equipoDestilacion.map((e) => {


                                const equipoHistorial = {
                                    data: {
                                        idelemento: parseInt(e.elemento.idelemento),
                                        tipootros: e.elemento.tipoOtros,
                                        cantidad: parseInt(e.cantidad),
                                        capacidad: parseFloat(e.capacidad),
                                        descripcion: e.descripcion,
                                        condicion: e.condicion,
                                        verificado: true,
                                        //idfi_25anexo: idanexo.idfi_25anexo
                                    }
                                }

                                const dataElementoClienteHistorial = {
                                    data: {
                                        cantidad: parseInt(e.cantidad),
                                        descripcion: e.descripcion,
                                        otro: "",
                                        idelemento: parseInt(e.elemento.idelemento),
                                        tipootros: e.elemento.tipoOtros,
                                        idseccion: 4,
                                        iddataelementocliente: e.iddataelementocliente
                                    }
                                }

                                dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                                dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial
                            })

                        } else {
                            console.log("vacio")
                        }

                        const destilacionContext = {
                            superficie: sup,
                            directo: valores.directo,
                            indirecto: valores.indirecto,
                            equipoDestilacion: valores.equipoDestilacion,
                            procesos: valores.procesos,
                            procesosPreguntas: procesosDestilacion,
                            categoria: totalCategoria,
                            submit: true
                        }

                        setContextDestilacion(destilacionContext)

                        Store.addNotification({
                            title: "Destilación!",
                            message: "Guardado Correctamente",
                            type: "success",
                            insert: "top",
                            container: "top-center",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                                duration: 3000,
                                onScreen: true
                            }
                        });
                    } catch (error) {
                        console.log(error)
                    }


                }}
            >
                {({ values }) => (
                    <Form>
                        {/* <div className='row'>
                             <label className={`${estilos.labelUI_title} mb-2`}>DESTILACIÓN</label>
                        </div>
                        */}
                        <div className={`${estilos.labelUI} row mb-2`}>
                            <label className={`${estilos.labelUI} mb-2`}>Superficie:</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-3 mb-3">
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="largo">Largo (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="largo" name="largo" placeholder="Largo" required />
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="ancho">Ancho (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="ancho" name="ancho" placeholder="Ancho" required />
                            </div>

                            <div className="col-md-2 mb-3">
                                <label htmlFor="area">Área (m²)</label>
                                <Field type="text" className="form-control form-control-sm" id="area" name="area" placeholder="Área" value={values.largo * values.ancho} required />
                            </div>
                        </div>
                        <hr />
                        <div className={`${estilos.labelUI} row mb-2`}>
                            <div className='col-md-5 mb-3'>
                                <label className={`${estilos.labelUI} mb-2`}>Forma de calentamiento:</label>
                            </div>
                            <div className="col-md-3 mb-3">
                                <label htmlFor='directo'>
                                    <Field className="form-check-input" type="checkbox" name="directo" id="directo" />
                                    <br />
                                    <div className='text-white'>Directo</div>
                                </label>

                            </div>
                            <div className="col-md-3 mb-3">
                                <label htmlFor="indirecto">
                                    <Field className="form-check-input" type="checkbox" name="indirecto" id="indirecto" />
                                    <br />
                                    <div className='text-white'>Indirecto</div>
                                </label>
                            </div>
                        </div>
                        <div className='table-responsive'>
                            <table className='table table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Cantidad</th>
                                        <th>Capacidad (L)</th>
                                        <th>Descripción y/o características</th>
                                        <th width="120">Condición</th>
                                        {//<th>Largo (m)</th>
                                            //<th>Ancho (m)</th>
                                            //<th>Área (m²)</th>
                                        }
                                        <th>Acciones</th>
                                        <th>Validar</th>
                                    </tr>
                                </thead>
                                <FieldArray
                                    name='equipoDestilacion'
                                    render={arrayHelpers => (
                                        <tbody>
                                            {equipoDestilacion &&
                                                equipoDestilacion.map((equipo, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {equipo.elemento.nombreelemento}
                                                            <h6>{equipo.elemento.tipoOtros}</h6>
                                                        </td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="cantidad" name={`equipoDestilacion.${index}.cantidad`} placeholder="Cantidad" required disabled={editarEquipo} /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="capacidad" name={`equipoDestilacion.${index}.capacidad`} placeholder="Capacidad" required disabled={editarEquipo} /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="descripcion" name={`equipoDestilacion.${index}.descripcion`} placeholder="Descripción" required disabled={editarEquipo} /></td>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="condicion"
                                                                name={`equipoDestilacion.${index}.condicion`}
                                                                className="form-select"
                                                                multiple={false}
                                                                disabled={editarEquipo}
                                                            >
                                                                <option defaultValue>Seleccione Condicion</option>
                                                                <option value={"Buena"}>Buena</option>
                                                                <option value={"Regular"}>Regular</option>
                                                                <option value={"Mala"}>Mala</option>
                                                            </Field>
                                                        </td>
                                                        {
                                                            //<td><Field type="text" className="form-control form-control-sm" id="largo" name={`equipoDestilacion.${index}.largo`} placeholder="Largo" disabled={editarEquipo} required /></td>
                                                            //<td><Field type="text" className="form-control form-control-sm" id="ancho" name={`equipoDestilacion.${index}.ancho`} placeholder="Ancho" disabled={editarEquipo} required /></td>
                                                            //<td><Field type="text" className="form-control form-control-sm" id="area" name={`equipoDestilacion.${index}.area`} placeholder="Área" value={superficie.area} disabled={editarEquipo} required /></td>
                                                        }
                                                        <td><button type="button" className='btn btn-warning btn-sm' onClick={() => handleModificar()}>Modificar</button> <hr /> <button type="button" className='btn btn-danger btn-sm' onClick={() => handleEliminarEquipo(equipo)}>Eliminar</button></td>
                                                        <td><Field className="form-check-input" type="checkbox" name={`equipoDestilacion.${index}.validar`} id="validar" /></td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    )}
                                />
                            </table>
                        </div>
                        <br />
                        <div style={{ textAlign: "center" }}>
                            <button type="button" className={`btn ${estilos.botonCircular}`} onClick={handleOpenModalNuevoEquipo}>+</button> Añadir nuevo equipo
                        </div>
                        <br />
                        <div className='row'>
                            <label className={`${estilos.labelUI} mb-2`}>MÉTODO</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-4 mb-3">
                                <label htmlFor="">PROCESO</label>
                            </div>
                            <div className="col-md-8 mb-3">
                                <label htmlFor="">DESCRIPCIÓN</label>
                            </div>
                        </div>
                        <FieldArray
                            name='procesos'
                            render={arrayHelpers => (
                                <div>
                                    {procesos.map((p, index) => (
                                        <div key={index}>
                                            <div className='row'>
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor={`proceso.${index}`}>{p.descripcion}</label>
                                                </div>
                                                <div className="col-md-8 mb-3">
                                                    <Field type="text" className="form-control form-control-sm" id={`procesos.${index}`} name={`procesos.${index}`} placeholder={p.descripcion} required />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        />


                        <hr></hr>
                        {
                            //<div className='row'>
                            //    <div className="row mb-5">
                            //        <div className="col ">
                            //            <button className={`btn ${estilos.botonVerdeCOMERCAM}`} type='submit'>GUARDAR</button>
                            //        </div>
                            //
                            //    </div>
                            //</div>
                        }

                        <hr />
                        <div style={{ textAlign: "center" }}>
                            <div className='row'>
                                <label className={`${estilos.labelUI} mb-2`}>DEFINICIÓN DE CATEGORÍA</label>
                            </div>

                            <div style={{ textAlign: "center" }}>
                                <p style={{ textAlign: "center" }}>Mediante la constatación física de las instalaciones antes descritas y con la información aportada por el productor de Mezcal de
                                    la empresa al momento de su entrevista, se recabo la evidencia necesaria para establecer que esta unidad de producción</p>
                                {
                                    totalCategoria === "mezcal" ?
                                        <h2>SI</h2>
                                        :
                                        totalCategoria === "mezcalartesanal" ?
                                            <h2>SI</h2>
                                            :
                                            totalCategoria === "mezcalancestral" ? //1
                                                <h2>SI</h2>
                                                :
                                                totalCategoria === "mezcal y mezcalartesanal" ?
                                                    <h2>SI</h2>
                                                    :
                                                    totalCategoria === "mezcal y mezcalancestral" ? //2
                                                        <h2>SI</h2>
                                                        :
                                                        totalCategoria === "mezcalartesanal y mezcal" ?
                                                            <h2>SI</h2>
                                                            :
                                                            totalCategoria === "mezcalartesanal y mezcalancestral" ? //3
                                                                <h2>SI</h2>
                                                                :
                                                                totalCategoria === "mezcalancestral y mezcal" ?
                                                                    <h2>SI</h2>
                                                                    :
                                                                    totalCategoria === "mezcal, mezcalancestral y mezcalartesanal" ?
                                                                        <h2>SI</h2>
                                                                        :
                                                                        totalCategoria === "mezcalancestral y mezcalartesanal" ? //4
                                                                            <h2>SI</h2>
                                                                            :
                                                                            <h2>NO</h2>
                                }
                                {
                                    //<center>
                                    //    <Field
                                    //        component="select"
                                    //        id="cumple"
                                    //        name="cumple"
                                    //        className="form-select form-select-sm"
                                    //        multiple={false}
                                    //        style={{ width: 100 }}
                                    //        onChange={handleCumple}
                                    //
                                    //    >
                                    //        { }
                                    //        <option defaultValue>...</option>
                                    //        <option value={1} >SI</option>
                                    //        <option value={2} >NO</option>
                                    //
                                    //    </Field>
                                    //</center>
                                }
                                <p>cumple con el apartado 4.4. de la NOM-070-SCFI-2016  y elabora Mezcal en la categoría:</p>
                            </div>

                            {
                                totalCategoria === "mezcal" ?
                                    <h2>MEZCAL</h2>
                                    :
                                    totalCategoria === "mezcalartesanal" ?
                                        <h2>MEZCAL ARTESANAL</h2>
                                        :
                                        totalCategoria === "mezcalancestral" ? //1
                                            <h2>MEZCAL ANCESTRAL</h2>
                                            :
                                            totalCategoria === "mezcal y mezcalartesanal" ?
                                                <h2>MEZCAL Y MEZCAL ARTESANAL</h2>
                                                :
                                                totalCategoria === "mezcal y mezcalancestral" ? //2
                                                    <h2>MEZCAL Y MEZCAL ANCESTRAL</h2>
                                                    :
                                                    totalCategoria === "mezcalartesanal y mezcal" ?
                                                        <h2>MEZCAL Y MEZCAL ARTESANAL</h2>
                                                        :
                                                        totalCategoria === "mezcalartesanal y mezcalancestral" ? //3
                                                            <h2>MEZCAL ARTESANAL Y MEZCAL ANCESTRAL</h2>
                                                            :
                                                            totalCategoria === "mezcalancestral y mezcal" ?
                                                                <h2>MEZCAL Y MEZCAL ANCESTRAL</h2>
                                                                :
                                                                totalCategoria === "mezcalancestral y mezcalartesanal" ? //4
                                                                    <h2>MEZCAL ANCESTRAL Y MEZCAL ARTESANAL</h2>
                                                                    :
                                                                    totalCategoria === "mezcal, mezcalancestral y mezcalartesanal" ? //4
                                                                        <h2>MEZCAL, MEZCAL ANCESTRAL Y MEZCAL ARTESANAL</h2>
                                                                        :
                                                                        <h2>NO IDENTIFICADA</h2>
                            }


                        </div>
                    </Form>
                )}
            </Formik>

            <div>
                {modalNuevoEquipo()}
            </div>
            <hr />
        </Fragment>
    );
};


export default withRouter(DestilacionFormComponent)
